import HiringManagerCard from "./HiringManagerCard";

export default HiringManagerCard;
